import type { GameStatus } from "../types/domain";

interface Props {
  status: GameStatus;
}

const STATUS_CLASSES: Record<GameStatus, string> = {
  in_progress: "bg-amber-100 text-amber-700",
  submitted: "bg-amber-100 text-amber-700",
  contested: "bg-rose-100 text-rose-700",
  validated: "bg-emerald-100 text-emerald-700",
  cancelled: "bg-gray-100 text-gray-600",
};

export function GameStatusPill({ status }: Props) {
  return (
    <span className={`status-pill ${STATUS_CLASSES[status]}`}>
      {gameStatusLabel(status)}
    </span>
  );
}

function gameStatusLabel(status: GameStatus): string {
  switch (status) {
    case "in_progress":
      return "En cours";
    case "cancelled":
      return "Annulée";
    case "submitted":
      return "Soumise";
    case "validated":
      return "Validée";
    case "contested":
      return "Contestée";
  }
}
